module.exports = __webpack_public_path__ + "img/powered-by-stripe.48b8190d.svg";